import * as z from "zod";

export const idSchema = z.union([
  z.string(),
  z.custom<{ toString(): string }>(
    (val) =>
      val !== null &&
      typeof val === "object" &&
      typeof (val as { toString(): string }).toString === "function",
    "Expected object with toString()",
  ),
]);

export const surrealRecordSchema = z.object({
  id: idSchema,
});
